import { createContext, useContext } from "react";
import { useProduct, useStockRegions } from "../adapters/uplist";
import { toCurrency } from "../helpers";
import { useBuyXGetOneFree } from "../hooks";

const StockPhotosContext = createContext();

export const StockPhotosProvider = (props) => {
  const { data: stock_regions } = useStockRegions();

  useBuyXGetOneFree({
    watch_sku: "stock_photos",
    free_sku: "1319",
    paid_sku: "1309",
    buy_x_count: 4,
  });

  const { data: product } = useProduct("1309");
  const individual_price = toCurrency(product?.price);

  return (
    <StockPhotosContext.Provider
      value={{ stock_regions, individual_price }}
      {...props}
    />
  );
};

export const useStockPhotos = () => useContext(StockPhotosContext);
